/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MinusSquareIcon16Light } from './MinusSquareIcon16Light';
import { MinusSquareIcon16Regular } from './MinusSquareIcon16Regular';
import { MinusSquareIcon16Solid } from './MinusSquareIcon16Solid';
import { MinusSquareIcon20Light } from './MinusSquareIcon20Light';
import { MinusSquareIcon20Regular } from './MinusSquareIcon20Regular';
import { MinusSquareIcon20Solid } from './MinusSquareIcon20Solid';
import { MinusSquareIcon24Regular } from './MinusSquareIcon24Regular';
import { MinusSquareIcon24Solid } from './MinusSquareIcon24Solid';
import { MinusSquareIcon32Regular } from './MinusSquareIcon32Regular';
import { MinusSquareIcon64Regular } from './MinusSquareIcon64Regular';
var sizes = {
    16: {
        light: MinusSquareIcon16Light,
        regular: MinusSquareIcon16Regular,
        solid: MinusSquareIcon16Solid,
    },
    20: {
        light: MinusSquareIcon20Light,
        regular: MinusSquareIcon20Regular,
        solid: MinusSquareIcon20Solid,
    },
    24: {
        regular: MinusSquareIcon24Regular,
        solid: MinusSquareIcon24Solid,
    },
    32: {
        regular: MinusSquareIcon32Regular,
    },
    64: {
        regular: MinusSquareIcon64Regular,
    },
};
export var MinusSquareIcon = forwardRef('MinusSquareIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
